import styled from '@emotion/styled'

import { palette, spacing } from 'main/ui'

interface IContainerProps {
  selected: boolean
}

export const Container = styled.div<IContainerProps>`
  align-items: center;
  background-color: ${palette.whiteDove};
  border: 1px solid ${({ selected }) => (selected ? palette.skyBlue : palette.chrome)};
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  padding: ${spacing.majorScale(2)}px ${spacing.majorScale(3)}px;

  > :not(:last-child) {
    margin-right: ${spacing.majorScale(2)}px;
  }
`
